export enum DisplayModes {
  Standard = 1,
  Narrow = 2
}
